;(function () {
  'use strict'

  angular
    .module('contrast.log-enhancer')
    .controller('DeleteLogEnhancerCtrl', [
      '$scope',
      '$uibModalInstance',
      'logEnhancerService',
      'log',
      DeleteLogEnhancerCtrl
    ])

  function DeleteLogEnhancerCtrl(
    $scope,
    $uibModalInstance,
    logEnhancerService,
    log
  ) {
    angular.extend($scope, {
      log: log,
      ok: ok,
      cancel: cancel
    })

    function ok() {
      logEnhancerService.deleteLogEnhancer(log.log_id).then(function () {
        $uibModalInstance.close()
      })
    }

    function cancel() {
      $uibModalInstance.dismiss('cancel')
    }
  }
})()
